module.exports = __webpack_public_path__ + "img/no-img.2f5aaaa5.jpg";